import { Router } from '@routes';
import { GlobalProvider } from '@providers/Global.provider';

export function App() {
  return (
    <GlobalProvider>
      <Router />
    </GlobalProvider>
  );
}
